import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_COST_PROVIDER_RESET = 'PUT_COST_PROVIDER_RESET';
export const PUT_COST_PROVIDER_LOADING = 'PUT_COST_PROVIDER_LOADING';
export const PUT_COST_PROVIDER_SUCCESS = 'PUT_COST_PROVIDER_SUCCESS';
export const PUT_COST_PROVIDER_REJECT = 'PUT_COST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const putCostProviderReset = () => ({ type: PUT_COST_PROVIDER_RESET });
export const putCostProviderLoading = () => ({ type: PUT_COST_PROVIDER_LOADING });
export const putCostProviderSuccess = (payload) => ({ type: PUT_COST_PROVIDER_SUCCESS, payload });
export const putCostProviderReject = (payload) => ({ type: PUT_COST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putCostProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Providers/web/UpdateProviderCosts`, options);
};


